module.exports = __webpack_public_path__ + "static/orkut_2-8bf56e4438f28d32ef3b1d7dc441101d.png";